$(document).ready(function(){        
/*$("input#login" ).focus(function() {
  $(this).attr('placeholder', '').parent().prev().css( "visibility", "visible" ).fadeIn("slow");
}).blur(function() {
    $(this).attr('placeholder', 'User Name').parent().prev().css( "visibility", "hidden");
});
    
 $("input#password" ).focus(function() {
  $(this).attr('placeholder', '').parent().prev().css( "visibility", "visible" ).fadeIn("slow");
}).blur(function() {
    $(this).attr('placeholder', 'Password').parent().prev().css( "visibility", "hidden");
});*/
    
$("input#login" ).focus(function() {
  $(this).parent().prev().removeClass("login-label");
}).blur(function() {
    $(this).parent().prev().addClass("login-label");    
});
    
$("input#password" ).focus(function() {
  $(this).parent().prev().removeClass("login-label");
}).blur(function() {
    $(this).parent().prev().addClass("login-label");    
});
    
});